import { CustomLink } from '@veranda/shared/components/custom-link';

export function BrandLink({
  name,
  slug,
  asSpan = false,
}: {
  name: string;
  slug: string;
  asSpan?: boolean;
}) {
  if (asSpan) {
    return <span className="font-medium text-primary text-sm">{name}</span>;
  }

  return (
    <CustomLink
      href={slug}
      className="font-medium text-primary text-sm hf:underline"
    >
      {name}
    </CustomLink>
  );
}
